import { ChangeEvent, useCallback, forwardRef } from 'react';
import InputMask from 'react-input-mask';

const unMaskRegex = new RegExp(/[^\d.+]/, 'g');
const unMask = (str: string) => str.replace(unMaskRegex, '');

export const PhoneNumberMask = forwardRef(
  (
    {
      value,
      onChange,
      ...other
    } // eslint-disable-next-line @typescript-eslint/no-explicit-any
    : any,
    _ref,
  ) => {
    const handleChange = useCallback(
      (event: ChangeEvent<HTMLInputElement>) => {
        const newValue = unMask(event.target.value);

        onChange({
          ...event,
          target: {
            name: event.target.name,
            value: newValue,
          },
        });
      },
      [onChange],
    );

    let mask = '(999) 999-9999';

    if (value?.length > unMask(mask).length) {
      mask += '9'.repeat(value.length - unMask(mask).length);
    }

    return <InputMask {...other} mask={mask} value={value} onChange={handleChange} />;
  },
);
